import { render, staticRenderFns } from "./contentDialog.vue?vue&type=template&id=a74484ac&scoped=true"
import script from "./contentDialog.vue?vue&type=script&lang=js"
export * from "./contentDialog.vue?vue&type=script&lang=js"
import style0 from "./contentDialog.vue?vue&type=style&index=0&id=a74484ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74484ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a74484ac')) {
      api.createRecord('a74484ac', component.options)
    } else {
      api.reload('a74484ac', component.options)
    }
    module.hot.accept("./contentDialog.vue?vue&type=template&id=a74484ac&scoped=true", function () {
      api.rerender('a74484ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/contentDialog.vue"
export default component.exports